const TECHNICAL_PATTERNS = [
  /\bselect\b.+\bfrom\b/i,
  /\binsert\s+into\b/i,
  /\bupdate\s+"/i,
  /\bdelete\s+from\b/i,
  /relation\s+"[^"]+"\s+does not exist/i,
  /column\s+"[^"]+"\s+does not exist/i,
  /\$\d+/,
  /ECONNREFUSED|ETIMEDOUT|ENOTFOUND/i,
  /\bat\s+[\w./<>]+\s+\(/,
  /node_modules\//i,
]

function extractMessage(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  if (error && typeof error === 'object' && 'message' in error) {
    const msg = (error as { message?: unknown }).message
    if (typeof msg === 'string') return msg
  }
  return ''
}

/**
 * Retourne un message affichable au joueur, sans détails techniques (SQL, stack, etc.).
 */
export function toPublicErrorMessage(
  error: unknown,
  fallback = 'Une erreur est survenue. Réessaie dans un instant.',
): string {
  const status =
    error && typeof error === 'object' && 'status' in error
      ? (error as { status?: number }).status
      : undefined
  if (typeof status === 'number' && status >= 500) return fallback

  const trimmed = extractMessage(error).trim()
  if (!trimmed) return fallback
  if (TECHNICAL_PATTERNS.some((re) => re.test(trimmed))) return fallback

  return trimmed.slice(0, 300)
}
